// Ro-Sham-Bo · Chicken Arcade — entry point.
// Boots the fixed-timestep App shell and hands off to the preloader scene.
// An offscreen live-region keeps a text loading state for a11y (and the E2E
// smoke check) while the canvas takes over visually.

import { App } from "./core/app";
import { PreloaderScene } from "./scenes/preloader";
import { session } from "./game/session";

const mount = document.querySelector<HTMLDivElement>("#app");

if (mount) {
  // Invite link support: ?room=CODE jumps straight into that private room
  // after the tap-in (see MenuScene.enter).
  const room = new URLSearchParams(location.search).get("room");
  if (room && /^[a-z0-9]{3,8}$/i.test(room)) {
    session.pendingRoom = room.toUpperCase();
  }

  const app = new App(mount);

  // Screen-reader / smoke-test status line (visually hidden under the canvas).
  const status = document.createElement("div");
  status.setAttribute("role", "status");
  status.style.position = "absolute";
  status.style.width = "1px";
  status.style.height = "1px";
  status.style.overflow = "hidden";
  status.style.clipPath = "inset(50%)";
  status.textContent = "loading…";
  mount.appendChild(status);

  app.setScene(new PreloaderScene(app));
  app.start();

  // Debug/playtest handle (read-mostly; same access DevTools already grants on
  // a fully client-side game). E2E drivers poll scene/phase state through it.
  (window as unknown as { __rsbApp?: App }).__rsbApp = app;
} else {
  // Should never happen — index.html always ships #app.
  document.body.textContent = "Ro-Sham-Bo failed to mount.";
}
